// removed by extract-text-webpack-plugin
module.exports = {"NavigationItem":"NavigationItem__NavigationItem__3YSjr","active":"NavigationItem__active__2GQz1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavigationItems/NavigationItem/NavigationItem.css
// module id = 140
// module chunks = 3